module.exports = __webpack_public_path__ + "static/media/left-arrow.34a4f31c.svg";